import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {MODULE, PageProps} from "core/metamodel/metaConstant";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import Grid from "core/grid/domain/grid";


const gridLocation = 'accountTransactionList';

let grid;

@observer
export default class BankTransactionList extends  PageAncestor<PageProps, undefined> {

  static module = MODULE.accounting;
  static title = 'Account Transactions';
  static icon = 'money';
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("BankTransactionList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        grid = new Grid(gridLocationMap.get(gridLocation), routerParams.id)
      });
  }


  render() {
    let {params, query} = this.props;


    return (
      <GridCompConnected grid={grid}  entities={mdEntityService.entityMap} gridId={params.gridId} query={query} />
    );
  }

}




// WEBPACK FOOTER //
// ./src/accounting/page/bankTransactionList.tsx